import React, { useState } from "react";
import { format } from "date-fns";
import { toZonedTime, fromZonedTime } from "date-fns-tz";

import { useTimeZoneContext } from "../../../../lib/context/TimeZone/TimeZoneContext";
import { attachHoursToDate } from "../../lib/dateInputConvert";

import { Person } from "../../../../api/grpc/contacts/contacts";
import { BookingsMapContext, IBookingsMapContext } from "./BookingsMapContext";

interface Props {
  children: React.ReactNode;
}

export const BookingsMapContextProvider = ({ children }: Props) => {
  const { timeZone } = useTimeZoneContext();
  // state
  const [time, setTime] = useState(toZonedTime(new Date(), timeZone));
  const [dateAndTime, setDateAndTime] = useState(new Date().toISOString());
  const [day, setDay] = useState(format(new Date(), "yyyy-MM-dd"));
  const [bookOnBehalfUser, setBookOnBehalfUser] = useState<Person | undefined>(
    undefined
  );
  const [notifyAssignee, setNotifyAssignee] = useState(false);
  const [allDay, setAllDay] = useState(false);
  const [searchedAttendees, setSearchedAttendees] = useState<Person[]>([]);
  const [reserveLaterTime, setReserveLaterTime] = useState<Date | undefined>(
    undefined
  );

  const handleTime = (time: Date) => {
    setTime(time);
  };

  const handleDay = (day: string) => {
    setDay(day);
  };

  const searchByDate = () => {
    let zonedDay = fromZonedTime(day, timeZone);

    setDateAndTime(
      attachHoursToDate(
        toZonedTime(zonedDay, timeZone).toISOString(),
        time,
        timeZone
      )
    );
  };

  const handleSearchedAttendees = (attende: Person[]) => {
    setSearchedAttendees([...attende]);
  };

  const context: IBookingsMapContext = {
    time,
    handleTime,
    day,
    handleDay,
    searchByDate,
    dateAndTime,
    setDateAndTime,
    searchedAttendees,
    bookOnBehalfUser,
    setBookOnBehalfUser,
    handleSearchedAttendees,
    allDay,
    setAllDay,
    notifyAssignee,
    setNotifyAssignee,
    reserveLaterTime,
    setReserveLaterTime,
  };

  return (
    <BookingsMapContext.Provider value={context}>
      {children}
    </BookingsMapContext.Provider>
  );
};
